/**
 * Smoothly scrolls the viewport so that the element with the given ID
 * is visible, accounting for sticky headers or other fixed UI.
 *
 * @param {string} elementId - The DOM id of the target element.
 * @param {Object}  [options]
 * @param {number}  [options.offset=-100]   - Pixel offset from the top of the viewport (negative = leave space above).
 * @param {number}  [options.delay=150]     - Milliseconds to wait before scrolling (lets the DOM settle).
 * @param {string}  [options.behavior="smooth"] - ScrollBehavior value.
 */
export function scrollToElement(
  elementId,
  { offset = -100, delay = 150, behavior = "smooth" } = {},
) {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return () => {};
  }

  const timeoutId = window.setTimeout(() => {
    const el = document.getElementById(elementId);
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY + offset;
      window.scrollTo({ top: y, behavior });
    }
  }, delay);

  return () => window.clearTimeout(timeoutId);
}
